import React, { Component } from 'react';
import { Card, Table, Form, DatePicker, Input, Button, Select, Checkbox} from 'antd';
import { withRouter, Page } from '@souche-f2e/muji';
import { connect } from '@souche-f2e/muji';
import styles from './index.module.less';
import Menu from '@/components/Dashboard/menu';
import { dispatch } from '@@/store';
import moment from 'moment';

const { RangePicker } = DatePicker;


const FormItem = Form.Item;
const { Option } = Select;

@withRouter
class TrafficStat extends Component{

    constructor() {
        super();
    }

    showAppList = () => {

        let { user, queryInfo } = this.props;

        user = user || {};
    
        const appList = user.appList || [];
    
        return (
            <Select 
                key="showAppCycle#"
                placeholder="请选择" 
                style={{ width: '160px' }}
                onChange={value => {
                    this.handleCycleChange({
                        appKey: value
                    });
                }}
                value={queryInfo.appKey}
            >
               <Option  value=''> 请选择 </Option>
                {
                    appList.map(elem => 
                        <Option  value={elem.appKey}> {elem.name} </Option>
                    )
                }
            </Select>
        )
    }

    showTimeRange = () => {
        
        const { queryInfo } = this.props;

        return (
            <RangePicker onChange={(date, dateStrings) => {
                this.handleCycleChange({
                    rangeStart: dateStrings[0],
                    rangeEnd: dateStrings[1]
                });
            }} 
            value={
                queryInfo.rangeStart && queryInfo.rangeEnd &&[moment(queryInfo.rangeStart), moment(queryInfo.rangeEnd)] || null
            }
            />
        )
    }


    showRows = () => {
        const { queryInfo } = this.props;

        return (
            <Select 
                key="showRows#"
                placeholder="请选择" 
                style={{ width: '160px' }}
                onChange={value => {
                    this.handleCycleChange({
                        toGetRows: value
                    });
                }}
                value={!!queryInfo.toGetRows}
            >
                {
                    [
                        {
                            value: false,
                            description: "应用"
                        },
                        {
                            value: true,
                            description: "接口"
                        }
                    ].map(elem => 
                        <Option  value={!!elem.value}> {elem.description} </Option>
                    )
                }
            </Select>
        )
    }

    handleCycleChange = (params) => {
        dispatch.traffic.SET_DAY_CYCLE({
            queryInfo: params
        })
    }

    okSearch = (params) => {

        let { isLogin } = this.props;

         // 检查 login 状态
        if (isLogin === false) {
            this.props.router.push('/signIn');
        }
  

        dispatch.traffic.queryTrafficStat(params);
    }

    getTableColumns = () => {

        const { trafficStat } = this.props;

        let columns = [
            {
                title: '接口API',
                dataIndex: 'uri',
                key: 'uri',
                width: '20%',
            },
            {
                title: '请求方式',
                dataIndex: 'method',
                key: 'method',
                width: '8%',
            },
            {
                title: '访问次数',
                dataIndex: 'totalCount',
                key: 'totalCount',
                width: '8%',
            },
            {
                title: '成功次数',
                dataIndex: 'successCount',
                key: 'successCount',
                width: '8%',
            },
            {
                title: '成功率',
                dataIndex: 'successPercent',
                key: 'successPercent',
                width: '8%',
            },
            {
                title: '请求IP',
                dataIndex: 'clientIps',
                key: 'clientIps',
                width: '30%',
                render: text => (
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>{text}</div>
                ),
            },
            {
                title: '日期',
                dataIndex: 'date',
                key: 'date',
                width: '10%',
            },
          ];

        if(!trafficStat[0] || !trafficStat[0].uri){
            delete columns[0];
            delete columns[1];
        }
    
        return columns;
    }

    render() {

        const { trafficStat, queryInfo }  = this.props;

        const trafficStatList = trafficStat.map((elem) => {
            elem.successPercent = `${ parseInt(elem.successCount / elem.totalCount * 100) }%`;
            return elem;
        })

       return ( 
            <div className={styles.detail}>
                <Menu />
                <div style={{ flex: 1 }}>
                <Card>
                    <Form layout="inline" style={ { "marginBottom":24 }}>
                        <FormItem label="应用" >
                        {
                          this.showAppList()
                        }
                        </FormItem>
            
                        <FormItem label="时间段" >
                        {
                          this.showTimeRange()
                        }
                        </FormItem>

                        <FormItem label="显示粒度" >
                        {
                          this.showRows()
                        }
                        </FormItem>

                        <FormItem>
                            <Button type="primary" onClick={() => this.okSearch(queryInfo)}>
                                搜索
                            </Button>
                        </FormItem>
                    </Form>


                    <Table columns={this.getTableColumns()} dataSource={trafficStatList}></Table> 
                </Card>
                </div>
            </div>
           
       )
    }
}



const mapStateToProps = (state, ownProps) => {
    const traffic = state.traffic;
    const user = state.user;
    return {
        trafficStat: traffic.trafficStat,
        queryInfo: traffic.queryInfo,
        user: user.user,
        isLogin: user.isLogin,
    }
  }
  
export default connect(mapStateToProps)(TrafficStat);